export const getPerformanceMark = () => Math.trunc(performance.now());

type Timestamped = {
	elapsed: number;
};

export type UserInteractedEvent = {
	type: 'user-interacted';
};

export type NavigationTimingEvent = {
	duration: number;
	transferSize: number;
	type: 'navigation-timing';
};

export type ResourceTimingEvent = {
	duration: number;
	initiatorType: string;
	start: number;
	transferSize: number;
	type: 'resource-timing';
};

export type LayoutShiftScoreEvent = {
	inputFlag: boolean;
	score: number;
	timestamp: number;
	type: 'dcls-score';
};

export type ResizeEvent = {
	height: number;
	type: 'resized';
};

export type ProductRequestsEvent = {
	authDuration: number;
	duration: number;
	type: 'productFetchRequest';
};

export type FunctionInvokedEvent = {
	duration: number;
	type: 'invoked';
};

export type FCPSnapshotEvent = {
	start: number;
	type: 'fcp-snapshot';
};

export type LCPSnapshotEvent = {
	size: number;
	start: number;
	type: 'lcp-snapshot';
};

export type AppPerformanceProfilingEvent = Timestamped &
	(
		| ResizeEvent
		| ProductRequestsEvent
		| UserInteractedEvent
		| NavigationTimingEvent
		| FunctionInvokedEvent
		| ResourceTimingEvent
		| LayoutShiftScoreEvent
		| FCPSnapshotEvent
		| LCPSnapshotEvent
	);
